export class MetresToFeetValueConverter {
    toView(value) {
        const convertedValue = value ? (value / 0.3048).toFixed(2) : 0;
        return `(${convertedValue} ft)`;
    }
}